import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LocationAndDateTimeRange } from '@wilson/interfaces';
import { addMinutes, subMinutes } from 'date-fns';
import { TransferType } from '../types';
import { PreviewCardComponent } from './preview-card/preview-card.component';
import { LocalizedDateTimeFormatPipe } from '@wilson/localization';

@Component({
  selector: 'wilson-transfer-preview',
  templateUrl: './transfer-preview.component.html',
  styleUrls: ['./transfer-preview.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    PreviewCardComponent,
    LocalizedDateTimeFormatPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransferPreviewComponent implements OnChanges {
  @Input() previousShift!: LocationAndDateTimeRange & {
    shiftId?: string;
  };
  @Input() nextShift!: LocationAndDateTimeRange & {
    shiftId?: string;
  };
  @Input() selectedTransferType!: TransferType;
  @Input() selectedDuration!: number;
  @Input() selectedDateTime!: Date;
  protected TransferType = TransferType;

  protected previousShiftTransferEndDateTime!: Date;
  protected nextShiftTransferStartDateTime!: Date;
  protected newShiftTransferStartDateTime!: Date;
  protected newShiftTransferEndDateTime!: Date;

  ngOnChanges(): void {
    this.previousShiftTransferEndDateTime = addMinutes(
      new Date(this.previousShift.endDateTime),
      this.selectedDuration,
    );
    this.nextShiftTransferStartDateTime = subMinutes(
      new Date(this.nextShift.startDateTime),
      this.selectedDuration,
    );
    this.newShiftTransferStartDateTime = this.selectedDateTime;
    this.newShiftTransferEndDateTime = addMinutes(
      this.selectedDateTime,
      this.selectedDuration,
    );
  }
}
